<template>
  <div class="form__control">
    <input
      type="hidden"
      ref="input"
      :name="name"
      v-model="token"
    >
    <vue-recaptcha
      @verify="onVerified"
      @expired="onExpired"
      ref="handler"
      :sitekey="sitekey"
    ></vue-recaptcha>
  </div>
</template>
 
<script>
  import VueRecaptcha from 'vue-recaptcha';
  export default {
    name: 'support-recaptcha',
    data: () => ({
      token: "",
    }),
    props: {
      name: String,
      sitekey: String
    },
    components: { VueRecaptcha },
    methods: {
      onVerified: function(recaptchaToken) {
        this.token = recaptchaToken;
        setTimeout(_ => {
          const event = new Event("change");
          this.$refs.input.dispatchEvent(event);
        }, 0);
      },
      onExpired: function(recaptchaToken) {
        this.token = "";
        setTimeout(_ => {
          const event = new Event("change");
          this.$refs.input.dispatchEvent(event);
        }, 0);
      }
    }
  };
</script>